<template>
	<v-row>
		<v-col
			cols="12"
			sm="6"
		>
			<v-card>
				<v-card-title>
					<translate>
						Point of Sale
					</translate>
				</v-card-title>
				<v-card-text>
					<v-form
						ref="form"
						v-model="pointOfSaleForm"
					>
						<v-row>
							<v-col>
								<v-text-field
									v-model="pointOfSale.name"
									color="primary"
									:rules="[v => !!v || $gettext('Name is required')]"
									:label="$gettext('Name')"
									required
								/>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-select
									v-model="pointOfSale.resellerId"
									:items="resellers"
									:rules="[v => !!v || $gettext('Reseller is required')]"
									item-value="id"
									item-title="name"
								/>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-select
									v-model="pointOfSale.pointofsaletypeId"
									:items="pointOfSaleTypes"
									:rules="[v => !!v || $gettext('Point of sale type is required')]"
									item-value="id"
									item-title="name"
								/>
							</v-col>
						</v-row>
						<v-form />
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn
						type="submit"
						@click="processSubmit"
					>
						<translate>Submit</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-col>
	</v-row>
</template>
<script>
import {
	axios,
} from '../../services/axios-service';
import {
	inform,
} from 'laravel-front-library';

export default {
	name: 'PointOfSaleEdit',

	props: {
		resellerId: {
			type: [Number, String, ],
			required: false,
			default: ''
		},
	},

	data () {
		return {
			breadCrumbs: {
				'/resellers': 'Resellers'
			},
			pointOfSale: {
				id: '',
				name: '',
				pointofsaletypeId: '',
				resellerId: '',
			},
			pointOfSaleTypes: [],
			resellers: [],
			pointOfSaleForm: null,
		};
	},
	async created () {
		const uri = window.location.search.substring(1);
		const params = new URLSearchParams(uri);

		this.pointOfSale.id = params.get('id');

		if (this.pointOfSale.id) {
			this.getData('/api/v0/pointofsales/', this.pointOfSale.id).then((result) => {
				this.pointOfSale = result;
			});
		} else {
			delete this.pointOfSale.id;
		}
		this.getData('/api/resellers?id=', this.resellerId).then((result) => {
			this.resellers = result;
		});
		this.getData('/api/v0/pointofsaletypes/').then((result) => {
			this.pointOfSaleTypes = result;
		});
	},

	methods: {
		/**
		 * @param {string} endpoint
		 * @param {string} id
		 */
		getData (endpoint, id = '') {
			return (new Promise((resolve) => {
				axios.get(`${endpoint}${id}`).then(({
					data
				}) => {
					resolve(data);
				}).catch((error) => {
					window.captureException(error);
					window.location.href = window.location.href.substring(0, window.location.href.lastIndexOf('/'));
				}
				);
			}));
		},


		/**
		 * Handle submit based on given point of sale
		 */
		processSubmit () {
			if (this.$refs.form.validate()) {
				this.submitPointOfSale();
			}
		},

		/**
		 * Do a put request for current point of sale data
		 */
		submitPointOfSale () {
			let axiosRequest;

			if (this.pointOfSale.id) {
				axiosRequest = axios.put(`/api/pointofsales/${this.pointOfSale.id}`, this.pointOfSale);
			} else {
				axiosRequest = axios.post('/api/pointofsales/', this.pointOfSale);
			}

			axiosRequest.then(() => {
				inform(this.$gettext('Point Of Sale updated'));
				window.location.href = window.location.href.substring(0, window.location.href.lastIndexOf('/'));
			}).catch((error) => {
				inform(this.$gettext('Submission failure.'));
				window.captureException(error);
			});
		},
	}
};
</script>
